__turbopack_context__.v({
  "active": "style-module__D9jm8q__active",
  "later": "style-module__D9jm8q__later",
  "loginAgain": "style-module__D9jm8q__loginAgain",
  "logout": "style-module__D9jm8q__logout",
  "logoutBtns": "style-module__D9jm8q__logoutBtns",
  "logoutContent": "style-module__D9jm8q__logoutContent",
});
